// extracted by mini-css-extract-plugin
export var active = "_uf-1";
export var circle = "_uf-0";
export var completed = "_uf-2";
export var connector = "_uf-4";
export var connectorCompleted = "_uf-7";
export var connectorSpacer = "_uf-5";
export var iconStrokeOverride = "_uf-8";
export var labelContainer = "_uf-6";
export var pending = "_uf-3";